<div class="child-panel card text-white border border-grey">
  <div class="card-body bg-primary p-3">
    <div class="child-panel-details">
      <div class="child-panel-name">
        <h5 class="mb-1">{{ child.Firstname }} {{ child.Lastname }}</h5>
        <ng-container [ngSwitch]="child.AccountPaymentState">
          <span class="font-size-12" *ngSwitchDefault>{{
            'child.panel.member.free.text' | translate: { fgbdefault: 'Rookie' }
          }}</span>
          <span class="font-size-12" *ngSwitchCase="1">{{
            'child.panel.member.paid.text' | translate: { fgbdefault: 'All-Star Member' }
          }}</span>
        </ng-container>
      </div>
      <div class="child-panel-dob">
        <label class="">{{ 'child.panel.dob' | translate }}</label>
        <span class="font-size-12">
          {{ child.DateOfBirth | date: 'MMM dd, yyyy' }}
        </span>
      </div>
    </div>
    <div class="img-wrapper">
      <img [src]="'logos/nav-logo.svg' | contentAssetImage" draggable="false" />
    </div>
  </div>
  <div class="button-wrapper w-100 bg-secondary login-kids-panel d-flex">
    <button
      type="button"
      (click)="loginToChild()"
      class="btn btn-primary mobile-child-login-btn fw-bold text-white cursor-pointer"
    >
      {{ 'child.panel.login' | translate }}
    </button>
    <button
      type="button"
      *ngIf="child.CardBarcode"
      (click)="open(barcodeModal)"
      class="btn btn-quaternary mobile-child-login-btn fw-bold text-black cursor-pointer"
    >
      {{ 'child.panel.show.card' | translate }}
    </button>
  </div>
</div>

<!-- Barcode modal -->
<ng-template #barcodeModal let-modal>
  <div class="child-barcode-modal">
    <div class="child-barcode-modal-body">
      <button class="child-barcode-modal-close-btn" (click)="modal.close()">
        <i class="material-symbols-outlined">close_small</i>
      </button>
      <div class="child-panel-name pt-3">
        <h5 class="mb-0 font-size-16">{{ child.Firstname }} {{ child.Lastname }}</h5>
        <ng-container [ngSwitch]="child.AccountPaymentState">
          <span class="font-size-12" *ngSwitchDefault>{{
            'child.panel.member.free.text' | translate: { fgbdefault: 'Club Member' }
          }}</span>
          <span class="font-size-12" *ngSwitchCase="1">{{
            'child.panel.member.paid.text' | translate: { fgbdefault: 'All-Star' }
          }}</span>
        </ng-container>
      </div>
      <div class="barcode-wrapper mt-3 mb-4">
        <qrcode [qrdata]="child.CardBarcode" [width]="120" [errorCorrectionLevel]="'M'" [elementType]="true"></qrcode>
      </div>
    </div>
    <div class="child-barcode-modal-footer bg-primary text-white">
      <div class="child-barcode-dob">
        <label class="mb-0">{{ 'child.panel.dob' | translate }}</label>
        <span class="font-size-12">
          {{ child.DateOfBirth | date: 'MMM dd, yyyy' }}
        </span>
      </div>
      <div class="child-barcode-logo">
        <img [src]="'logos/nav-logo.svg' | contentAssetImage" alt="" />
      </div>
    </div>
  </div>
</ng-template>
